var map = {
	"./music-instructions.json": 5490,
	"./music-library-intro2024.json": 5491,
	"./music-library-launch2024.json": 5492,
	"./music-progression.json": 5493,
	"./startSourcesAdvanced.json": 5494,
	"./startSourcesSimple.json": 5495,
	"./startSourcesSimple2.json": 5496,
	"./startSourcesTracks.json": 5497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5052;